/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_4_AnswerInputs */

const en_svc_agents_faq_4_answer = /** @type {(inputs: Svc_Agents_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both. Simple, well-structured workflows often fit n8n; agents that need more control, testing or custom logic are built in code. We recommend one during discovery and explain why.`)
};

const lv_svc_agents_faq_4_answer = /** @type {(inputs: Svc_Agents_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abos. Vienkāršām, skaidri strukturētām darba plūsmām bieži der n8n; aģentus, kam vajag vairāk kontroles, testēšanas vai savas loģikas, veidojam kodā. Izpētes laikā iesakām vienu no variantiem un paskaidrojam, kāpēc.`)
};

/**
* | output |
* | --- |
* | "Both. Simple, well-structured workflows often fit n8n; agents that need more control, testing or custom logic are built in code. We recommend one during disc..." |
*
* @param {Svc_Agents_Faq_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_4_answer = /** @type {((inputs?: Svc_Agents_Faq_4_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_4_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_4_answer(inputs)
	return en_svc_agents_faq_4_answer(inputs)
});